import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useBnsMeiJieWenDangUpdateQuery, useBnsMeiJieWenDangUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
function DocEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bmjwd_content:''
    }); 
    const {data,isSuccess} = useBnsMeiJieWenDangUpdateQuery({bmjwd_id:props.bmjwd_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bmjwd_name:data.Result.bmjwd_name,
                    bmjwd_dept_id:data.Result.bmjwd_dept_id,
                    bmjwd_content:data.Result.bmjwd_content,                   
                })
                setInfo(prevState=>({...prevState,
                    bmjwd_name:data.Result.bmjwd_name,
                    bmjwd_dept_id:data.Result.bmjwd_dept_id,
                    bmjwd_dept_name:data.Result.bmjwd_dept_name,
                    bmjwd_content:data.Result.bmjwd_content,                         
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsMeiJieWenDangUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改媒体文档'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({  
                        bmjwd_bmj_id:props.bmj_id,                    
                        "bmjwd_uid" : localStorage.getItem('eu_id'),
                        "bmjwd_uname" : localStorage.getItem('eu_name'),
                        "bmjwd_content" : info.bmjwd_content,
                        "bmjwd_dept_id" : info.bmjwd_dept_id,
                        "bmjwd_dept_name" : info.bmjwd_dept_name,
                        "bmjwd_e_id" : localStorage.getItem('e_id'),                    
                        "bmjwd_name" : info.bmjwd_name,                              
                        "bmjwd_id" : props.bmjwd_id,                                
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                > 
                    <Form.Item name="bmjwd_name" label='名称' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bmjwd_name:e.target.value}))}}
                        />
                    </Form.Item>     
                    <Form.Item
                        label='备注'
                        wrapperCol={{span:20}}
                        name='bmjwd_content'
                    >
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,bmjwd_content:e}))}}/>
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default DocEdit